import React, {useContext, useEffect, useState} from 'react';
import ImportList from "./ImportList";
import DashboardTable from "./DashboardTable";
import axios from "axios";
import authContext from "../../AuthProvider/authContext";
import UserList from "../AdminDashboard";

const Dashboard = () => {
    const [recentStocks, setRecentStocks] = useState([]);
    const [isLoadingStocks, setLoadingStocks] = useState(false);
    const {state} = useContext(authContext);

    let initialized = false;
    useEffect(() => {
        if (!initialized) {
            setLoadingStocks(true);
            initialized = true;
            getFilesList();
        }
    }, []);

    const getFilesList = (page = 1,isLoading = true) => {
        axios.get(`/api/get-file?sort=created_at:desc&page=${page}&filter=${state.filter}`)
            .then((response) => {
                setLoadingStocks(false);
                setRecentStocks(response.data.data);
                if (window.location.pathname === "/dashboard" && isLoading) {
                    setTimeout(()=> {
                        getFilesList(page);
                    },8000);
                }
            }).catch((err) => {})
    }

    const props = {isLoadingStocks, recentStocks, getFilesList,state};

    return (
        <div>
            <div className="dashboard-content">
                <ImportList {...props} />
                <DashboardTable {...props} />
            </div>
        </div>
    );
};

export default Dashboard;
